export default __webpack_public_path__ + "static/media/10.b3ab20f2.png";